import { render, staticRenderFns } from "./StatisticsStatus.vue?vue&type=template&id=8fe405f0&scoped=true"
import script from "./StatisticsStatus.vue?vue&type=script&lang=js"
export * from "./StatisticsStatus.vue?vue&type=script&lang=js"
import style0 from "./StatisticsStatus.vue?vue&type=style&index=0&id=8fe405f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe405f0",
  null
  
)

export default component.exports